import Grid from "@mui/material/Unstable_Grid2/Grid2";
import FormSectionGrid from "../Form/FormSectionGrid";
import FormSectionHeader from "../Form/FormSectionHeader";
import LabelValue from "./LabelValue";
import { ReasonForExam } from "../../../types/common";

const ExamReason = ({
  pageText,
  candidateDetails,
  lookupData,
  examDetails,
}: {
  pageText: any;
  candidateDetails: any;
  lookupData: any;
  examDetails: any;
}) => {
  return (
    <>
      <FormSectionHeader>
        {pageText?.textMetadata?.reasonforexamtext}
      </FormSectionHeader>
      <FormSectionGrid>
        <Grid xs={12}>
          <LabelValue
            label={pageText?.labelsMetadata.reasonForExamLabel}
            value={
              lookupData?.reasonForExam[candidateDetails?.examReason?.value]
            }
          />
        </Grid>
        {candidateDetails?.examReason.value === ReasonForExam.UKVisaPurposes &&
          examDetails?.isExamEligibleForUkVisa && (
            <>
              <Grid xs={12} sm={6}>
                <LabelValue
                  label={pageText?.labelsMetadata.passportNoLabel}
                  value={candidateDetails?.PassportNo}
                />
              </Grid>
              <Grid xs={12} sm={6}>
                <LabelValue
                  label={pageText?.labelsMetadata.passportExpiryLabel}
                  value={`${
                    candidateDetails?.passportEx?.day?.value <= 9
                      ? "0" + candidateDetails?.passportEx?.day?.value
                      : candidateDetails?.passportEx?.day?.value
                  }/${candidateDetails?.passportEx?.month?.value}/${
                    candidateDetails?.passportEx?.year?.value
                  }`}
                />
              </Grid>
            </>
          )}
      </FormSectionGrid>
    </>
  );
};

export default ExamReason;
